export default {
  loading: {
    en: 'Loading...',
  },
}
